import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LsCheckboxComponent } from './ls-checkbox.component';
import { DynamicTranslationModule } from '../../../dynamic-translation/dynamic-translation.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DynamicTranslationModule
  ],
  declarations: [LsCheckboxComponent],
  exports: [LsCheckboxComponent]
})
export class LsCheckboxModule {}
